/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

declare let onetext : OneText;

export const BrandLogoWhite = () : JSX.Element => {
    return (
        <div className={ 'w-[56px] h-[56px] md:w-[70px] md:h-[70px]' }>
            <svg
                id={ 'Caden_Lane_Popup_Logo' }
                data-name={ 'Caden Lane Popup Logo' }
                xmlns={ 'http://www.w3.org/2000/svg' }
                viewBox={ '0 0 144.46 144.46' }>
                <defs>
                    <style>
                        {
                            `
                                .cadenlane-popup-logo-1 {
                                    fill: #ffffff;
                                }
                                .cadenlane-popup-logo-1, .cadenlane-popup-logo-2 {
                                    stroke-width: 0px;
                                }
                                .cadenlane-popup-logo-2 {
                                    fill: #010101;
                                }
                            `
                        }
                    </style>
                </defs>
                <g
                    id={ 'Caden_Lane_Popup_Logo_Group_1' }
                    data-name={ 'Caden Lane Popup Logo Group 1' }>
                    <g>
                        <g>
                            <circle
                                className={ 'cadenlane-popup-logo-1' }
                                cx={ '72.23' }
                                cy={ '72.23' }
                                r={ '71.59' } />
                            <path
                                className={ 'cadenlane-popup-logo-2' }
                                // eslint-disable-next-line @stylistic/max-len
                                d={ 'M72.23,144.46C32.4,144.46,0,112.06,0,72.23S32.4,0,72.23,0s72.23,32.4,72.23,72.23-32.4,72.23-72.23,72.23ZM72.23,1.29C33.12,1.29,1.29,33.12,1.29,72.23s31.82,70.94,70.94,70.94,70.94-31.82,70.94-70.94S111.35,1.29,72.23,1.29Z' } />
                        </g>
                        <rect
                            className={ 'cadenlane-popup-logo-2' }
                            x={ '71.37' }
                            y={ '22.83' }
                            width={ '1.29' }
                            height={ '99.44' } />
                        <path
                            className={ 'cadenlane-popup-logo-2' }
                            // eslint-disable-next-line @stylistic/max-len
                            d={ 'M28.94,52c4.86-3.8,11.05-5.66,17.98-5.66,3.6,0,8.66.73,11.79,1.6.8.2,1.26.33,1.86.27.07,1.53.4,5.73.93,9.79-.33.47-1.33.53-1.8.13-1-4.53-4-9.72-13.65-9.72-10.19,0-18.84,6.46-18.84,20.24s8.86,21.71,19.78,21.71c8.59,0,12.39-5.59,13.92-9.52.47-.33,1.46-.2,1.73.27-.47,3.46-2.2,7.86-3.2,9.12-.8.13-1.6.4-2.33.67-1.46.53-6.26,1.53-10.52,1.53-5.99,0-11.72-1.2-16.58-4.46-5.33-3.66-9.46-9.72-9.46-18.31,0-7.39,3.33-13.72,8.39-17.65Z' } />
                        <path
                            className={ 'cadenlane-popup-logo-2' }
                            // eslint-disable-next-line @stylistic/max-len
                            d={ 'M93.33,57.39c0-6.99-.13-8.06-4.33-8.39l-1.67-.13c-.4-.27-.27-1.46.13-1.66,3.73.13,5.99.2,8.66.2s4.86-.07,8.19-.2c.4.2.53,1.4.13,1.66l-1.6.13c-3.93.33-4.06,1.4-4.06,8.39v23.17c0,4.19.2,5.93,1.4,7.19.73.73,2,1.53,7.26,1.53,5.66,0,7.06-.27,8.12-.87,1.33-.8,3.06-3.2,4.39-6.59.4-.33,1.67-.07,1.67.4,0,.73-1.87,7.52-2.8,9.32-3.4-.13-9.72-.2-16.58-.2h-6.13c-2.8,0-4.93.07-8.66.2-.4-.2-.53-1.27-.13-1.66l2-.2c3.86-.4,4-1.33,4-8.32v-23.97Z' } />
                    </g>
                </g>
            </svg>
        </div>
    );
};
